/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ yearly_price_month: NonNullable<unknown>, view_all_plans: NonNullable<unknown> }} Yearly_Subscription_FooterInputs */

const en_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, cancel anytime. ${i?.view_all_plans}`)
};

const ar_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تعادل ${i?.yearly_price_month}/شهريًا، يمكنك الإلغاء في أي وقت. ${i?.view_all_plans}`)
};

const de_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entspricht ${i?.yearly_price_month}/Monat, jederzeit kündbar. ${i?.view_all_plans}`)
};

const es_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Igual a ${i?.yearly_price_month} / mes, cancela en cualquier momento. ${i?.view_all_plans}`)
};

const fr_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soit ${i?.yearly_price_month}/mois, résiliable à tout moment. ${i?.view_all_plans}`)
};

const it_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uguale a ${i?.yearly_price_month}/mese, annulla in qualsiasi momento. ${i?.view_all_plans}`)
};

const ja_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price_month}/月、いつでもキャンセル可能。${i?.view_all_plans}`)
};

const ko_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`월 ${i?.yearly_price_month} 꼴, 언제든지 취소 가능. ${i?.view_all_plans}`)
};

const pt_br_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equivale a ${i?.yearly_price_month}/mês, cancele quando quiser. ${i?.view_all_plans}`)
};

const ru_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Составляет ${i?.yearly_price_month}/месяц, отменяйте в любое время. ${i?.view_all_plans}`)
};

const th_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เท่ากับ ${i?.yearly_price_month}/เดือน ยกเลิกได้ทุกเมื่อ ${i?.view_all_plans}`)
};

const tr_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fiyatı aylık ${i?.yearly_price_month} idir, istediğin zaman iptal edebilirsin. ${i?.view_all_plans}`)
};

const zh_cn_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相当于 ${i?.yearly_price_month}/月，随时可取消。 ${i?.view_all_plans}`)
};

const zh_tw_yearly_subscription_footer = /** @type {(inputs: Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相當於 ${i?.yearly_price_month}/月，隨時可取消。 ${i?.view_all_plans}`)
};

/**
* | output |
* | --- |
* | "Equals {yearly_price_month}/month, cancel anytime. {view_all_plans}" |
*
* @param {Yearly_Subscription_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const yearly_subscription_footer = /** @type {((inputs: Yearly_Subscription_FooterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yearly_Subscription_FooterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yearly_subscription_footer(inputs)
	if (locale === "ar") return ar_yearly_subscription_footer(inputs)
	if (locale === "de") return de_yearly_subscription_footer(inputs)
	if (locale === "es") return es_yearly_subscription_footer(inputs)
	if (locale === "fr") return fr_yearly_subscription_footer(inputs)
	if (locale === "it") return it_yearly_subscription_footer(inputs)
	if (locale === "ja") return ja_yearly_subscription_footer(inputs)
	if (locale === "ko") return ko_yearly_subscription_footer(inputs)
	if (locale === "pt_br") return pt_br_yearly_subscription_footer(inputs)
	if (locale === "ru") return ru_yearly_subscription_footer(inputs)
	if (locale === "th") return th_yearly_subscription_footer(inputs)
	if (locale === "tr") return tr_yearly_subscription_footer(inputs)
	if (locale === "zh_cn") return zh_cn_yearly_subscription_footer(inputs)
	return zh_tw_yearly_subscription_footer(inputs)
});